import { mockEducationApi } from './mockEducationApi';
import { educationApiMethods } from './educationApiContract';
import { useEducationModuleContext } from '../host/educationModuleContext';

export { educationApiMethods } from './educationApiContract';

export function validateEducationApi(api, source = 'Education module educationApi') {
  educationApiMethods.forEach((method) => {
    if (typeof api?.[method] !== 'function') {
      throw new Error(`${source}.${method} is required`);
    }
  });
}

export function resolveEducationApi(host = {}) {
  const api = host.educationApi || mockEducationApi;

  validateEducationApi(api);

  return api;
}

export function useEducationApi() {
  const { educationApi } = useEducationModuleContext();

  if (!educationApi) {
    throw new Error('Education api is not provided');
  }

  return educationApi;
}
